import { Dispatch, ThunkAction } from '../../../types/actions';
import { ECardChecklistOrderMode } from '../../../types/rest/IUserMeta';
import { IGetState } from '../../../types/types';
import { IAuthUser } from '../../../store/model/authUser/types';
import { authUserPatch } from './api/helper/authUserPatch';

export const authUserSetChecklistOrderMode = (
    userId: string,
    checklistOrderMode: ECardChecklistOrderMode
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const userPatch: IAuthUser = {
            id: userId,
            meta: {
                checklistOrderMode
            }
        };
        return dispatch(authUserPatch(userPatch));
    };
    return action;
};
